'use client';

import { useEffect, useRef } from 'react';

export const useCookiebot = () => {
    const cookiebotCreated = useRef(false);

    useEffect(() => {
        if (cookiebotCreated.current) return;

        const script = document.createElement('script');
        script.src = 'https://consent.cookiebot.com/uc.js';
        script.id = 'Cookiebot';
        script.dataset.cbid = 'a378c2c1-9730-4e23-90d8-dc7e6fd6da89';
        script.type = 'text/javascript';
        script.async = true;

        document.body.append(script);

        cookiebotCreated.current = true;

        return () => {
            script.remove();
        };
    }, []);
};
